import { Select, SelectProps } from 'antd';
import { useEffect, useState } from 'react';

import { useGPStatusList } from '@/core/domain/visual-management/status/status.hooks';

type Props = Omit<SelectProps, 'options'> & {
  queryEnable?: boolean;
};

export default function StatusSelectField({
  queryEnable = false,
  ...props
}: Props) {
  const [selectClicked, setSelectClicked] = useState<boolean>(queryEnable);
  const [searchValue, setSearchValue] = useState<string>();

  const isMultiple = props.mode === 'multiple';

  useEffect(() => {
    setSelectClicked(queryEnable);
  }, [queryEnable]);

  const { data, isFetching } = useGPStatusList(selectClicked);

  const options = data?.map((item) => ({ value: item.id, label: item.name }));

  return (
    <Select
      loading={isFetching}
      options={options}
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      style={{ width: '100%' }}
      maxTagCount={isMultiple ? 'responsive' : undefined}
      maxTagTextLength={isMultiple ? 30 : undefined}
      {...props}
    />
  );
}
